const translations = {
  he: {
    // Nav
    nav: {
      items: [
        { number: '01', label: 'פרויקטים', targetId: 'פרויקטים' },
        { number: '02', label: 'אודות', targetId: 'about' },
        { number: '03', label: 'הופעות במגזינים וטלוויזיה', targetId: 'מגזינים' },
        { number: '04', label: 'צרו קשר', action: 'whatsapp' },
      ],
      openMenu: 'פתח תפריט',
      closeMenu: 'סגור תפריט',
      phone: 'טלפון',
      email: 'אימייל',
      follow: 'עקבו',
      footerTagline: 'סטודיו בוטיק לעיצוב פנים',
      whatsappMessage: 'היי נרקיס הגעתי מהדף שלך אשמח שנדבר!',
    },

    // Hero / FirstScreen
    hero: {
      loaderText: 'טוען את החוויה',
      featuredLabel: 'כפי שפורסמה ב',
      stat1Number: '200+',
      stat1Label: 'בתים מעוצבים',
      stat2Number: '14+',
      stat2Label: 'שנות ניסיון',
      stat3Number: '100%',
      stat3Label: 'עמידה בתקציב',
      ctaText: 'בואו נדבר על הבית שלכם',
      whatsappText: 'היי%20נרקיס%20הגעתי%20מהדף%20שלך%20אשמח%20לשמוע%20עוד%20על..',
    },

    // ThirdScreen
    third: {
      openingTitle: 'אם הגעתם לכאן',
      openingText: 'סימן שהבנתם שהבית שלכם הוא לא רק "ארבעה קירות". הוא המקום שבו הילדים גדלים, המקום אליו אתם בורחים בסוף יום עבודה, והנכס הכי יקר ומשמעותי שתקנו בחייכם.',
      painTitle: 'אתם לא מוכנים להתפשר על "בערך":',
      painPoints: [
        'אתם חולמים על בית שנראה כמו במגזינים, אבל שגם יהיה פרקטי לחיים האמיתיים.',
        'אתם מרגישים שהחלל שלכם "קטן" מדי, אבל יודעים שעם תכנון ואחסון נכון אפשר להגדיל אותו מבלי להזיז קירות.',
        'אתם לא רוצים "עוד בית" ותהליך מייגע - אתם רוצים ביטחון, שקט ותוצאה שמרגשת אתכם.',
      ],
      missionTitle: 'המטרה שלי? להפוך את הבית שלכם למנוע של רוגע',
      missionText1: 'אני לא כאן רק כדי לבחור צבע לקיר. המטרה שלי היא לייצר עבורכם <strong>חלל שישרת אתכם וייראה מיליון דולר!</strong> כזה שפותר את הכאבים הכי קטנים של היום־יום: מפינת התיקים והמעילים שלא תפסה מקום, ועד לתכנון מטבח שבו הכל נמצא בדיוק במקום שבו היד שלכם מחפשת אותו ועדיין כל מי שיגיע אליכם לביקור יחמיא לכם על העיצוב המטורף..',
      missionText2: 'אני כאן כדי לקחת את כל הבלבול, הדמיון שלכם והחלומות הלא מגובשים - ולזקק אותם לכדי <strong>חלל אחד שלם, יוקרתי, מאורגן ופונקציונלי</strong>.',
      principlesTitle: 'אלו העקרונות שמובילים אותי בכל פרויקט:',
      principles: [
        { title: 'הקשבה לפני הכל', text: 'אני לא באה עם תוכנית מוכנה. אני לומדת את אורח החיים שלכם, את הרגלי הבוקר שלכם ואת הצרכים הייחודיים של המשפחה שלכם.', number: '01' },
        { title: 'תכנון חכם הוא היוקרה החדשה', text: 'יופי הוא חשוב, אבל בית חכם שבו יש פתרון לכל פריט אחסון - זה מה שיוצר איכות חיים אמיתית.', number: '02' },
        { title: 'אפס ניחושים', text: 'עם הדמיות תלת־מימד מפורטות, אתם תראו את הבית שלכם וממש ״תוכלו לטייל בו״. אתם תלכו לישון בשקט כי אתם יודעים בדיוק איך זה הולך להיראות.', number: '03' },
        { title: 'ליווי מקצה לקצה', text: 'מהסקיצה הראשונה, דרך ימי רכישה ממוקדים ועד לתליית התמונה האחרונה. אני שם כדי למנוע טעויות יקרות ולחסוך לכם זמן, כסף, טעויות מיותרות וכאבי ראש מיותרים.', number: '04' },
      ],
      transitionText: 'עכשיו אני בטוחה שהסתקרנתם איך הדברים קורים בפועל...',
      transitionSubtext: 'אז בואו נצלול לעומק...',
    },

    // Quote
    quote: {
      sentence: 'המטרה היא בית שישרת את המשפחה ורק אז יהיה מעוצב בצורה מיוחדת - לא ההפך',
    },

    // About / Me
    about: {
      greeting: 'נעים מאוד,',
      name: 'נרקיס רובין ברזני',
      quote: 'אני לא רק מעצבת בתים - אני תופרת אותם בדיוק למידה של הלקוחות שלי',
      story1: 'כל החיים ידעתי שאני אוהבת לעצב. קיבלתי החלטה ללכת אחרי התשוקה האמיתית שלי. הלכתי ללמוד עיצוב פנים ב<span class="highlight">שנקר</span>, <span class="highlight">סיימתי בהצטיינות</span>, והפכתי למרצה שם. כבר <span class="highlight">יותר מ-14 שנה</span> אני עוסקת בתכנון ועיצוב פנים. בתים שעיצבתי הופיעו ב<span class="highlight">מגזינים בארץ ובחו"ל</span>, <span class="highlight">בטלוויזיה ובפורבס</span>. מאז בעשור האחרון ליוויתי <span class="highlight">מאות בתים</span> ויותר חשוב -  מאות משפחות לבית החלומות שלהן',
      story2: 'מה שמניע אותי כל בוקר זה הפנים של הלקוחות שלי בסוף התהליך כשכל הפאזל מתחבר להם. אני פוגשת כל לקוח ולקוחה שלי ונכנסת איתם לעובי הקורה - על אורח החיים שלהם, על איך הם קמים בבוקר, מה הם עושים לפני השינה, איפה הנעליים נמצאות, איפה הדייסון, המעילים, איפה הם רוצים שהתיקים יהיו, מה עושים בכל חדר ומה הדבר הראשון שהם עושים ברגע שהם מגיעים הביתה - ומשם - אני אוספת את כל זה ויוצרת <span class="highlight">בית מאורגן, מסודר, פרקטי ומעוצב</span> שנותן פתרונות חכמים לצרכים שלהם.',
      story3: '<span class="highlightStrong">המטרה שלי פשוטה:</span> בית שישרת אתכם - ולא להיפך. בית שבו יש <span class="highlight">מקום לכל דבר</span>, שבו אתם חיים בנוחות ובסדר, ושבו אתם באמת <span class="highlight">מרגישים בבית</span>. הלקוחות שלי איתי <span class="highlight">יד ביד</span> - מרגע התכנון ועד התמונה האחרונה על הקיר. אני דואגת שהכל יהיה <span class="highlight">מתוכנן ומתוקצב בצורה מדויקת</span>, מגשרת בין כל בעלי המקצוע, ומלווה אתכם בכל שלב - מהחזון הראשוני ועד סידור האקססוריז האחרון.',
      ctaText: 'בואו נדבר על הבית שלכם',
    },

    // Recommendations
    rec: {
      title: 'מה הלקוחות אומרים',
      subtitle: 'גללו וגלו מה הלקוחות שלי אומרים אחרי התהליך',
      ctaText: 'בואו נדבר',
      altPrefix: 'המלצה',
    },

    // Process
    process: {
      mainTitle: 'תהליך העבודה איתי',
      ctaText: 'לשיחה אישית איתי לחצו כאן',
      steps: [
        {
          title: 'אפיון עומק ופגישת קונספט',
          description: 'זה השלב שבו אני לומדת את ה-DNA שלכם. אני מגיעה אליכם, פותחת ארונות, מבינה את הרגלי הבוקר והלילה, ומתרגמת את החלומות ביותר לתוכנית פעולה. לא מתחילים לפני שאני מבינה בדיוק מי אתם ואיך הבית צריך לשרת אתכם.',
          highlight: 'לתפור לכם בית בדיוק למידותיכם, כמו שמלה',
        },
        {
          title: 'הדמיות תלת-מימד שלא נותנות מקום לדמיון',
          description: 'בלי דמיונות ובלי ניחושים. אני לוקחת את התוכניות והופכת אותן למודל תלת-מימדי חי ונושם. אתם תטיילו בבית החדש שלכם עוד לפני שהונחה הלבנה הראשונה, תרגישו את המרחבים ותדעו ב-100% וודאות איך התוצאה הסופית תיראה (גם אם תתעוררו מתוך שינה :) ).',
          highlight: 'שקט נפשי מלא - רואים את הסוף כבר בהתחלה',
        },
        {
          title: 'תכנון פנים חכם וכתב כמויות',
          description: 'כאן הופכים את היופי לפרקטיקה. אני יורדת לרזולוציות הקטנות ביותר: תוכניות הריסה, חשמל, בנייה, אינסטלציה, תקרות ונגרות מתוחכמת שמייצרת פתרונות אחסון יש מאין. במקביל, אני בונה כתב כמויות מדויק ללא "כוכביות" והפתעות, כדי שתישארו בשליטה תקציבית.',
          highlight: 'עיצוב שעובד בשבילכם, עם תקציב שלא חורג בשקל',
        },
        {
          title: 'ימי רכש וליווי ספקים VIP',
          description: 'יוצאים לשטח. אני מלווה אתכם בימי הקניות באולמות התצוגה, חוסכת לכם התלבטויות וכאבי ראש, ומשתמשת בניסיון שלי כדי להשיג עבורכם את המחירים הטובים ביותר. אנחנו בוחרים יחד הכל - מהריצוף והמטבח ועד הכורסה בסלון.',
          highlight: 'חיסכון עצום בכסף, בזמן ובאנרגיה',
        },
        {
          title: 'פיקוח עליון וסטיילינג עד התמונה האחרונה',
          description: 'אני החוט המקשר ביניכם לבין אנשי הביצוע. דואגת שהתוכניות מתבצעות במדויק מול הקבלן, פותרת בעיות בזמן אמת, ומסיימת בהלבשת הבית (סטיילינג) - הנחת השטיחים, האקססוריז ותליית התמונה האחרונה על הקיר.',
          highlight: 'אתם לא לבד מול בעלי המקצוע - ליווי צמוד מא\' ועד ת\'',
        },
      ],
    },

    // Projects Gallery
    projectsGallery: {
      title: 'רגע לפני שנדבר...',
      subtitle: 'הציצו בפרויקטים האחרונים שלנו - לחצו על כל פרוייקט כדי לקבל עליו עוד פרטים',
      viewProject: 'צפייה בפרויקט',
      flagshipProject: 'פרויקט הדגל',
      ctaText: 'לשיחת ייעוץ לחצו כאן',
      photoGallery: 'גלריית תמונות',
      photos: 'תמונות',
      featuredIn: 'הופיע ב-',
      projects: [
        {
          title: 'בית פרטי בשילת',
          subtitle: 'עיצוב פנים מקיף',
          area: '380 מ"ר',
          description: 'בית משפחתי מרווח במושב שילת, המשלב עיצוב כפרי-מודרני עם חומרים טבעיים. התכנון התמקד ביצירת זרימה טבעית בין החללים הפנימיים לחצר הירוקה, תוך שמירה על אווירה חמה ומזמינה לכל המשפחה.',
        },
        {
          title: 'יוקרה במגדל',
          subtitle: 'דירת יוקרה אורבנית',
          area: '220 מ"ר',
          description: 'דירת יוקרה במגדל מגורים יוקרתי בתל אביב. העיצוב משלב קווים נקיים ומודרניים עם נגיעות של חומרים עשירים כמו שיש, עץ אלון ופליז. הנוף הפנורמי לעיר היווה השראה מרכזית בתכנון החללים.',
        },
        {
          title: 'בית הפליסה',
          subtitle: 'בית פרטי ברמת חן',
          area: '450 מ"ר',
          description: 'בית פרטי מרשים ברמת חן, המכונה "בית הפליסה" בזכות עבודת הפליסה הייחודית שמשתלבת לאורך כל הבית. שילוב של אדריכלות קלאסית עם עיצוב פנים עכשווי, תוך דגש על פרטים מדויקים ואיכות ביצוע גבוהה.',
        },
        {
          title: 'דירה תל אביבית בשחקים',
          subtitle: 'פנטהאוז עירוני',
          area: '180 מ"ר',
          description: 'דירת יוקרה בקומות הגבוהות של תל אביב, עם נוף פנורמי עוצר נשימה. העיצוב משלב אלגנטיות עירונית עם נוחות ביתית, תוך ניצול מקסימלי של האור הטבעי והנוף. חומרים איכותיים ופרטים מדויקים יוצרים חלל מגורים מרשים ומזמין.',
        },
      ],
    },

    // More Projects
    moreProjects: {
      title: 'עוד מהפרויקטים שלנו',
      subtitle: 'מבחר עיצובים נוספים מהסטודיו',
      photos: 'תמונות',
      viewProject: 'צפייה בפרויקט',
      featuredLabel: 'הופיע ב:',
      ctaText: 'לחצו כאן לשיחת ייעוץ',
      photoGallery: 'גלריית תמונות',
      loadingGallery: 'טוען גלריה...',
      modalCtaText: 'אהבתי! אשמח שנדבר!',
    },

    // Before After
    beforeAfter: {
      title: 'לפני ואחרי',
      subtitle: 'גלו את הקסם שמתרחש בכל פרויקט',
      before: 'לפני',
      after: 'אחרי',
      ctaText: 'רוצים לראות את הקסם אצלכם בבית?',
      ctaButton: 'בואו נדבר',
      projects: [
        { title: 'בית פרטי בשילת' },
        { title: 'דירת יוקרה במגדל' },
        { title: 'בית הפליסה' },
        { title: 'פנטהאוז תל אביבי' },
      ],
    },

    // FAQ
    faq: {
      badge: 'שאלות נפוצות',
      title: 'כל מה שרצית לדעת',
      subtitle: 'התשובות לשאלות שרוב הלקוחות שואלים לפני שמתחילים את המסע לבית החלומות',
      ctaText: 'יש לך שאלה שלא מופיעה כאן?',
      ctaButton: 'בואי נדבר',
      items: [
        {
          question: 'אני מפחדת להתחיל תהליך שיפוץ כי זה נשמע מלחיץ ומתיש',
          answer: 'את לא לבד בזה, והפחד הזה הגיוני לגמרי. ההבדל הוא שכשיש מישהי שמלווה אותך צעד אחרי צעד - מהתכנון ועד הפרט האחרון - הלחץ הופך לריגוש. את לא צריכה לזכור הכל, לרדוף אחרי קבלנים או לפחד מטעויות. זו העבודה שלי.'
        },
        {
          question: 'יש לי בית קטן ואני לא בטוחה שאפשר לעשות איתו משהו משמעותי',
          answer: 'דווקא בבתים קטנים קורה הקסם הכי גדול. עם תכנון חכם, כל סנטימטר עובד בשבילך - אחסון מוסתר, פתרונות כפולי שימוש, ותחושת מרחב שלא האמנת שאפשרית. ראיתי דירות של 60 מטר שמרגישות כמו 90. הכל מתחיל ונגמר בתכנון.'
        },
        {
          question: 'מה אם בסוף זה לא ייראה כמו שדמיינתי?',
          answer: 'בדיוק בשביל זה יש הדמיות תלת-ממדיות. לפני שמזיזים אפילו כיסא אחד, את רואה את הבית המוגמר על המסך - כל חדר, כל זווית, כל פרט. אפשר לשנות, להתאים ולשפר עד שזה בדיוק מה שחלמת. אפס הפתעות.'
        },
        {
          question: 'אני לא יודעת מה הסגנון שלי בכלל',
          answer: 'רוב האנשים לא יודעים להגדיר את הסגנון שלהם במילים - וזה בסדר גמור. בפגישת ההיכרות אני שואלת שאלות על החיים שלך, לא על עיצוב. איך נראה הבוקר שלך? מה מרגיע אותך? איפה את הכי אוהבת לשבת? מהתשובות האלה אני בונה את השפה העיצובית שהיא באמת שלך.'
        },
        {
          question: 'כבר עשינו שיפוץ פעם ונשארנו עם תחושה של החמצה',
          answer: 'את לא היחידה. הרבה אנשים מגיעים אליי אחרי שיפוץ שלא יצא כמו שרצו - ודווקא הניסיון הזה עוזר להם להבין כמה חשוב ליווי מקצועי מההתחלה. הפעם נעשה את זה אחרת, עם תכנון מדויק שלא משאיר מקום לניחושים.'
        },
      ],
    },

    // Shorts
    shorts: {
      title: 'ולמקרה שתרצו להתעמק..',
      description: 'קיבצתי עבורכם התארחויות שלי בטלויזיה, ודעות שלי לגבי נושאים שחשוב שתדעו לפני שתקחו מעצבת פנים',
    },

    // Form
    form: {
      title: 'לכל שאלה נוספת..',
      subtitle: 'השאירו פרטים ונחזור אליכם בהקדם לשיחת ייעוץ ללא התחייבות',
      successTitle: 'הטופס נשלח בהצלחה!',
      successText: 'נחזור אליכם בהקדם האפשרי',
      fullName: 'שם מלא',
      phone: 'מספר טלפון',
      reason: 'סיבת פנייה',
      expansion: 'הרחבה',
      optional: '(אופציונלי)',
      fullNamePlaceholder: 'הזינו את שמכם המלא',
      phonePlaceholder: '050-1234567',
      reasonPlaceholder: 'בחרו סיבת פנייה',
      expansionPlaceholder: 'ספרו לנו עוד על הפרויקט שלכם...',
      reasonOptions: [
        { value: 'שיפוץ', label: 'שיפוץ' },
        { value: 'קניתי דירה מקבלן', label: 'קניתי דירה מקבלן' },
        { value: 'עיצוב פנים', label: 'עיצוב פנים' },
        { value: 'ייעוץ', label: 'ייעוץ' },
        { value: 'אחר', label: 'אחר' },
      ],
      privacyPrefix: 'קראתי את',
      privacySuffix: 'ואני מאשר/ת',
      privacyAlert: 'עליך לאשר את תנאי השימוש ומדיניות הפרטיות',
      submitText: 'שלחו הודעה',
      submittingText: 'שולח...',
      errorText: 'התרחשה שגיאה, אנא נסו שוב מאוחר יותר',
      orContact: 'או צרו קשר ישירות',
      errorFullName: 'נא להזין שם מלא',
      errorFullNameMin: 'שם חייב להכיל לפחות 2 תווים',
      errorPhone: 'נא להזין מספר טלפון',
      errorPhoneInvalid: 'נא להזין מספר טלפון תקין',
      errorReason: 'נא לבחור סיבת פנייה',
    },

    // Privacy
    privacy: {
      linkText: 'תקנון ומדיניות פרטיות',
      closeButton: 'סגירה',
      ownerName: 'נרקיס רובין ברזני',
    },

    // ByMe
    byMe: {
      text: 'נבנה על ידי',
      name: 'דניאל רוזנבלט',
    },

    // projectsConfig titles
    projectsConfigTitles: {
      1: { title: 'בית פרטי בשילת', subtitle: 'אורבניות בכפר' },
      2: { title: 'יוקרה במגדל', subtitle: 'דירת יוקרה אורבנית' },
      3: { title: 'בית הפליסה', subtitle: 'בית פרטי ברמת חן' },
      4: { title: 'פנטהאוז תל אביבי', subtitle: 'הגוש הגדול' },
      5: { title: 'בית מודרני ואלגנטי', subtitle: 'כפר בילו' },
      6: { title: 'בית פרטי כפרי', subtitle: 'קריית אונו' },
      7: { title: 'דופלקס תל אביבי הפוך', subtitle: 'רמת אביב' },
      8: { title: 'בית שמח מודרני', subtitle: 'מושב גיבתון' },
      9: { title: 'דירת בוטיק', subtitle: 'הרצליה הילס' },
      10: { title: 'פנטהאוז כפרי', subtitle: 'עיצוב פנים מקיף' },
      11: { title: 'בית פרטי בשחור ולבן', subtitle: 'ניגודיות מושלמת' },
      12: { title: 'בית פרטי', subtitle: 'עיצוב מודרני' },
      13: { title: 'דירה תל אביבית בשחקים', subtitle: 'מגדלי דה וינצ\'י' },
      14: { title: 'דירת קבלן משודרגת', subtitle: 'עיצוב מודרני' },
      15: { title: 'בית כפרי מתועש', subtitle: 'כפרי קלאסי' },
      16: { title: 'דופלקס בשחור ולבן', subtitle: 'עיצוב דרמטי' },
      17: { title: 'חלום טוסקני', subtitle: 'דופלקס כפרי' },
      18: { title: 'בית פרטי וחם', subtitle: 'עיצוב מודרני' },
      19: { title: 'Minimal House', subtitle: 'כפר אורנים' },
      20: { title: 'בית בניחוח ספרדי', subtitle: 'Casa Azul' },
    },
  },

  en: {
    // Nav
    nav: {
      items: [
        { number: '01', label: 'Projects', targetId: 'פרויקטים' },
        { number: '02', label: 'About', targetId: 'about' },
        { number: '03', label: 'TV & Magazine Features', targetId: 'מגזינים' },
        { number: '04', label: 'Contact Us', action: 'whatsapp' },
      ],
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      phone: 'Phone',
      email: 'Email',
      follow: 'Follow',
      footerTagline: 'Boutique Interior Design Studio',
      whatsappMessage: 'Hi Narkis, I came from your website and would love to chat!',
    },

    // Hero / FirstScreen
    hero: {
      loaderText: 'Loading the experience',
      featuredLabel: 'As Featured In',
      stat1Number: '200+',
      stat1Label: 'Designed Homes',
      stat2Number: '14+',
      stat2Label: 'Years of Experience',
      stat3Number: '100%',
      stat3Label: 'On Budget',
      ctaText: "Let's talk about your home",
      whatsappText: 'Hi%20Narkis%2C%20I%20came%20from%20your%20website%20and%20would%20love%20to%20hear%20more%20about..',
    },

    // ThirdScreen
    third: {
      openingTitle: "If you've made it here",
      openingText: "It means you understand that your home is more than just \"four walls.\" It's where your children grow, the place you escape to at the end of a workday, and the most valuable and meaningful asset you'll ever purchase.",
      painTitle: "You're not willing to settle for \"good enough\":",
      painPoints: [
        'You dream of a home that looks like it belongs in a magazine, but is also practical for real life.',
        'You feel like your space is "too small," but you know that with smart planning and proper storage, you can make it feel larger without moving walls.',
        "You don't want \"just another house\" and an exhausting process - you want confidence, peace of mind, and a result that excites you.",
      ],
      missionTitle: 'My goal? To turn your home into a sanctuary of calm',
      missionText1: "I'm not here just to pick a wall color. My goal is to create <strong>a space that works for you and looks like a million dollars!</strong> One that solves the everyday hassles: from the bags and coats that never had a proper spot, to a kitchen where everything is exactly where you reach for it - and still, every guest who walks in will rave about your stunning design.",
      missionText2: "I'm here to take all the confusion, your imagination, and your half-formed dreams - and distill them into <strong>one complete, luxurious, organized, and functional space</strong>.",
      principlesTitle: 'These are the principles that guide me in every project:',
      principles: [
        { title: 'Listening comes first', text: "I don't come with a ready-made plan. I study your lifestyle, your morning habits, and your family's unique needs.", number: '01' },
        { title: 'Smart planning is the new luxury', text: "Beauty matters, but a smart home with a solution for every storage need - that's what creates real quality of life.", number: '02' },
        { title: 'Zero guesswork', text: 'With detailed 3D renderings, you\'ll see your home and practically "walk through it." You\'ll sleep peacefully knowing exactly how it will look.', number: '03' },
        { title: 'End-to-end guidance', text: "From the first sketch, through focused shopping days, to hanging the last picture. I'm there to prevent costly mistakes and save you time, money, and unnecessary headaches.", number: '04' },
      ],
      transitionText: "I'm sure you're curious how things actually work...",
      transitionSubtext: "So let's dive deeper...",
    },

    // Quote
    quote: {
      sentence: "The goal is a home that works for the family first, and looks beautiful second - never the other way around",
    },

    // About / Me
    about: {
      greeting: 'Nice to meet you,',
      name: 'Narkis Rubin Barazani',
      quote: "I don't just design homes - I tailor them to fit my clients perfectly",
      story1: 'I always knew I loved design. I decided to follow my true passion - I studied interior design at <span class="highlight">Shenkar College</span>, <span class="highlight">graduated with honors</span>, and went on to lecture there. For <span class="highlight">over 14 years</span> I\'ve been planning and designing interiors. My work has been featured in <span class="highlight">magazines in Israel and internationally</span>, as well as <span class="highlight">on television and in Forbes</span>. Over the past decade, I\'ve transformed <span class="highlight">hundreds of homes</span> - and more importantly, helped hundreds of families create the home of their dreams.',
      story2: 'What drives me every morning is seeing my clients\' faces at the end of the process, when every piece of the puzzle clicks into place. I sit down with each client and dive deep into their world - their lifestyle, how they start their morning, what they do before bed, where the shoes go, where the vacuum lives, where the coats belong, what happens in each room, and the very first thing they do when they walk through the door. From there, I take it all and create an <span class="highlight">organized, tidy, practical, and beautifully designed home</span> with smart solutions for their everyday needs.',
      story3: '<span class="highlightStrong">My goal is simple:</span> a home that works for you - not the other way around. A home where there\'s <span class="highlight">a place for everything</span>, where you live in comfort and order, and where you truly <span class="highlight">feel at home</span>. My clients walk this journey with me <span class="highlight">hand in hand</span> - from the very first sketch to the last picture on the wall. I make sure everything is <span class="highlight">planned and budgeted down to the last detail</span>, coordinating all the professionals and guiding you through every step - from the initial vision to styling the final accessory.',
      ctaText: "Let's talk about your home",
    },

    // Recommendations
    rec: {
      title: 'What clients are saying',
      subtitle: 'See what my clients have to say after working together',
      ctaText: "Let's talk",
      altPrefix: 'Testimonial',
    },

    // Process
    process: {
      mainTitle: 'My Work Process',
      ctaText: 'Click here for a personal consultation',
      steps: [
        {
          title: 'Deep Profiling & Concept Meeting',
          description: "This is where I get to know who you really are. I visit your home, open closets, understand your morning and evening routines, and translate your biggest dreams into an action plan. We don't start until I understand exactly who you are and how your home needs to work for you.",
          highlight: 'A home custom-tailored to fit your life perfectly',
        },
        {
          title: '3D Renderings That Leave Nothing to the Imagination',
          description: "No guessing, no surprises. I take the plans and turn them into a vivid 3D model. You'll walk through your new home before a single brick is laid, feel the spaces, and know with 100% certainty how the final result will look.",
          highlight: 'Complete peace of mind - see the end from the beginning',
        },
        {
          title: 'Smart Interior Planning & Bill of Quantities',
          description: "This is where beauty meets practicality. I dive into the finest details: demolition plans, electrical, construction, plumbing, ceilings, and custom carpentry that creates storage solutions out of thin air. At the same time, I prepare a detailed cost breakdown with no hidden fees or surprises, so you stay in full control of your budget.",
          highlight: 'Design that works for you, on a budget that stays on track',
        },
        {
          title: 'Shopping Days & VIP Supplier Guidance',
          description: "Time to shop. I join you on curated shopping days at showrooms, saving you from indecision and headaches, and using my experience to get you the best prices. We choose everything together - from tiles and kitchen fittings to the perfect living room armchair.",
          highlight: 'Massive savings in money, time, and energy',
        },
        {
          title: 'Superior Supervision & Styling to the Last Picture',
          description: "I'm the bridge between you and the contractors. I make sure plans are executed to perfection, solve problems in real time, and finish with full home styling - laying the rugs, placing the accessories, and hanging the last picture on the wall.",
          highlight: "You're not alone with the professionals - close guidance from A to Z",
        },
      ],
    },

    // Projects Gallery
    projectsGallery: {
      title: 'Before we talk...',
      subtitle: 'Take a peek at our latest projects - click on each project for more details',
      viewProject: 'View Project',
      flagshipProject: 'Flagship Project',
      ctaText: 'Click here for a consultation',
      photoGallery: 'Photo Gallery',
      photos: 'photos',
      featuredIn: 'Featured in ',
      projects: [
        {
          title: 'Private Home in Shilat',
          subtitle: 'Comprehensive Interior Design',
          area: '380 sqm',
          description: 'A spacious family home in Moshav Shilat, combining rustic-modern design with natural materials. The planning focused on creating a natural flow between interior spaces and the green yard, while maintaining a warm and inviting atmosphere for the whole family.',
        },
        {
          title: 'Tower Luxury',
          subtitle: 'Urban Luxury Apartment',
          area: '220 sqm',
          description: 'A luxury apartment in a prestigious residential tower in Tel Aviv. The design combines clean, modern lines with touches of rich materials like marble, oak wood, and brass. The panoramic city view served as a central inspiration in space planning.',
        },
        {
          title: 'The Brass House',
          subtitle: 'Private Home in Ramat Chen',
          area: '450 sqm',
          description: 'An impressive private home in Ramat Chen, named "The Brass House" thanks to the unique brasswork that runs throughout the home. A combination of classic architecture with contemporary interior design, emphasizing precise details and high execution quality.',
        },
        {
          title: 'Tel Aviv Sky Apartment',
          subtitle: 'Urban Penthouse',
          area: '180 sqm',
          description: 'A luxury apartment on the top floors of Tel Aviv, with a breathtaking panoramic view. The design combines urban elegance with home comfort, maximizing natural light and views. Quality materials and precise details create an impressive and inviting living space.',
        },
      ],
    },

    // More Projects
    moreProjects: {
      title: 'More of Our Projects',
      subtitle: 'A selection of additional designs from the studio',
      photos: 'photos',
      viewProject: 'View Project',
      featuredLabel: 'Featured in:',
      ctaText: 'Click here for a consultation',
      photoGallery: 'Photo Gallery',
      loadingGallery: 'Loading gallery...',
      modalCtaText: "Love it! Let's talk!",
    },

    // Before After
    beforeAfter: {
      title: 'Before & After',
      subtitle: 'Discover the magic that happens in every project',
      before: 'Before',
      after: 'After',
      ctaText: 'Want to see the magic in your home?',
      ctaButton: "Let's talk",
      projects: [
        { title: 'Private Home in Shilat' },
        { title: 'Tower Luxury Apartment' },
        { title: 'The Brass House' },
        { title: 'Tel Aviv Penthouse' },
      ],
    },

    // FAQ
    faq: {
      badge: 'FAQ',
      title: 'Everything you wanted to know',
      subtitle: 'Answers to the questions most clients ask before starting their dream home journey',
      ctaText: "Have a question that isn't listed here?",
      ctaButton: "Let's talk",
      items: [
        {
          question: "I'm afraid to start a renovation process because it sounds stressful and exhausting",
          answer: "You're not alone in this, and that fear is completely valid. But the difference is that when someone guides you step by step - from planning to the last detail - stress turns into excitement. You don't have to remember everything, chase contractors, or worry about mistakes. That's my job."
        },
        {
          question: "I have a small home and I'm not sure anything significant can be done with it",
          answer: "Small homes are actually where the biggest transformations happen. With smart planning, every square foot works for you - hidden storage, dual-purpose solutions, and a sense of space you didn't think was possible. I've seen compact apartments that feel twice their size. It all comes down to planning."
        },
        {
          question: "What if in the end it doesn't look like what I imagined?",
          answer: "That's exactly what the 3D renderings are for. Before a single chair is moved, you see the finished home on screen - every room, every angle, every detail. You can tweak, adjust, and refine until it's exactly what you envisioned. Zero surprises."
        },
        {
          question: "I don't even know what my style is",
          answer: "Most people can't define their style in words - and that's perfectly fine. In our first meeting, I ask questions about your life, not about design. What does your morning look like? What relaxes you? Where's your favorite spot to sit? From those answers, I build a design language that's truly yours."
        },
        {
          question: "We've already done a renovation once and were left with a feeling of disappointment",
          answer: "You're not the only one. Many clients come to me after a renovation that didn't turn out the way they hoped - and that experience is exactly what helps them see the value of professional guidance from day one. This time, we do it right, with precise planning that leaves nothing to chance."
        },
      ],
    },

    // Shorts
    shorts: {
      title: 'Want to learn more?',
      description: "I've compiled my TV appearances and insights on what you should know before hiring an interior designer",
    },

    // Form
    form: {
      title: 'For any additional questions..',
      subtitle: 'Leave your details and we\'ll get back to you shortly for a free, no-obligation consultation',
      successTitle: 'Form submitted successfully!',
      successText: 'We will get back to you as soon as possible',
      fullName: 'Full Name',
      phone: 'Phone Number',
      reason: 'Reason for Inquiry',
      expansion: 'Additional Details',
      optional: '(optional)',
      fullNamePlaceholder: 'Enter your full name',
      phonePlaceholder: '+1 (555) 123-4567',
      reasonPlaceholder: 'Select a reason',
      expansionPlaceholder: 'Tell us more about your project...',
      reasonOptions: [
        { value: 'Renovation', label: 'Renovation' },
        { value: 'New construction / developer apartment', label: 'New Construction' },
        { value: 'Interior design', label: 'Interior design' },
        { value: 'Consultation', label: 'Consultation' },
        { value: 'Other', label: 'Other' },
      ],
      privacyPrefix: 'I have read the',
      privacySuffix: 'and I agree',
      privacyAlert: 'You must accept the terms of service and privacy policy',
      submitText: 'Send Message',
      submittingText: 'Sending...',
      errorText: 'An error occurred, please try again later',
      orContact: 'Or contact us directly',
      errorFullName: 'Please enter your full name',
      errorFullNameMin: 'Name must contain at least 2 characters',
      errorPhone: 'Please enter a phone number',
      errorPhoneInvalid: 'Please enter a valid phone number',
      errorReason: 'Please select a reason',
    },

    // Privacy
    privacy: {
      linkText: 'Terms & Privacy Policy',
      closeButton: 'Close',
      ownerName: 'Narkis Rubin Barazani',
    },

    // ByMe
    byMe: {
      text: 'Built by',
      name: 'Daniel Rozenblat',
    },

    // projectsConfig titles
    projectsConfigTitles: {
      1: { title: 'Private Home in Shilat', subtitle: 'Urban in the Village' },
      2: { title: 'Tower Luxury', subtitle: 'Urban Luxury Apartment' },
      3: { title: 'The Brass House', subtitle: 'Private Home in Ramat Chen' },
      4: { title: 'Tel Aviv Penthouse', subtitle: 'HaGush HaGadol' },
      5: { title: 'Modern & Elegant Home', subtitle: 'Kfar Bilu' },
      6: { title: 'Rustic Private Home', subtitle: 'Kiryat Ono' },
      7: { title: 'Upside-Down Tel Aviv Duplex', subtitle: 'Ramat Aviv' },
      8: { title: 'Cheerful Modern Home', subtitle: 'Moshav Givaton' },
      9: { title: 'Boutique Apartment', subtitle: 'Herzliya Hills' },
      10: { title: 'Rustic Penthouse', subtitle: 'Comprehensive Interior Design' },
      11: { title: 'Black & White Home', subtitle: 'Perfect Contrast' },
      12: { title: 'Private Home', subtitle: 'Modern Design' },
      13: { title: 'Tel Aviv Sky Apartment', subtitle: "Da Vinci Towers" },
      14: { title: 'Upgraded New Build', subtitle: 'Modern Design' },
      15: { title: 'Industrial Rustic Home', subtitle: 'Rustic Classic' },
      16: { title: 'Black & White Duplex', subtitle: 'Dramatic Design' },
      17: { title: 'Tuscan Dream', subtitle: 'Rustic Duplex' },
      18: { title: 'Warm Private Home', subtitle: 'Modern Design' },
      19: { title: 'Minimal House', subtitle: 'Kfar Oranim' },
      20: { title: 'Spanish-Inspired Home', subtitle: 'Casa Azul' },
    },
  },
};

export const t = (lang) => translations[lang] || translations.he;

export default translations;
